// var url={img:''}
// if(window.location.hostname=='192.168.1.25'){
//     url.img='http://192.168.1.25:8160'
// }
// else if(window.location.hostname=='project.urasr.com'){
//     url.img='http://project.urasr.com'
// }
// else{
//     url.img='http://192.168.1.25:8160'
// }
// export default url
var wms={url:''}
if(window.location.hostname=='192.168.1.11' || window.location.hostname=='192.168.1.252' ){
    wms.url='http://192.168.1.24:8080/geoserver/zhongzi/wms'
    // wms.url='http://192.168.1.117:8080/geoserver/zhongzi/wms'
}
else if(window.location.hostname=='seed.urasr.com'){
    wms.url='https://seed.urasr.com/geoserver/zhongzi/wms'
}else if(window.location.hostname=='dev.urasr.com'){
    wms.url='https://dev.urasr.com/geoserver/zhongzi/wms'
}else if(window.location.hostname=='seedtest.urasr.com'){
    wms.url="https://seedtest.urasr.com/geoserver/zhongzi/wms"
}
// else{
//     wms.url='https://seed.urasr.com/geoserver/zhongzi/wms'
// }
export default wms



// WEBPACK FOOTER //
// ./src/api/url.js